export default "__VITE_ASSET__COWvjWXS__"